<template>
  <div class="io-sidebar-element">
    <a
      :href="item.url"
      :class="{
        'active': isActive || childActive,
        'open': showChildren,
      }"
      :title="item.label"
      @click.prevent="showChildrenOrPass($event, item.url)"
    >
      <template v-for="(icon, inx) in icons">
        <i
          v-if="hasIcon"
          :key="icon"
          class="link-icon fal fa-fw"
          :class="[icon, inx === 1 ? 'link-icon--overlay' : '']"
        />
      </template>
      <span
        v-if="!isChild && !hasIcon"
        class="link-icon fa-layers fa-fw"
      >
        <i class="fal fa-circle" />
        <span
          class="fa-layers-text text-body"
          data-fa-transform="shrink-10"
          style="font-weight:700"
        >
          {{ item.label.substr(0, 2).toUpperCase() }}
        </span>
      </span>

      {{ item.label }}

      <i
        v-if="hasChildren"
        class="link-chevron fal fa-chevron-down"
      />
    </a>
    <div
      v-if="hasChildren"
      class="children"
    >
      <Expansion
        v-model="showChildren"
        :duration="animationDuration"
      >
        <SidebarLink
          v-for="child in item.children"
          :key="child.index"
          ref="childs"
          :is-open="isOpen"
          :item="child"
          :is-child="true"
          :url-path="urlPath"
          :layer="layer + 1"
          @showChildren="hideOtherChildren"
          @active="childActive = $event"
        />
      </Expansion>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarLink',

  props: {
    layer: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    isChild: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    isOpen: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    urlPath: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      showChildren: false,
      childActive: false,
      animationDuration: 0.45,
    };
  },

  computed: {
    isActive() {
      return this.checkActive();
    },
    icons() {
      const icons = this.IOH.recVal(this.item, 'label_extras.prefix.icon');
      return icons instanceof Array ? icons : [icons];
    },
    hasIcon() {
      return this.icon !== null;
    },
    hasChildren() {
      return this.IOH.recVal(this.item, 'children', []).length > 0;
    },
  },

  watch: {
    isOpen() {
      this.showChildren = this.isOpen && this.hasActiveChild(this.IOH.recVal(this.item, 'children', []));
    },
    showChildren(val) {
      if (val) {
        setTimeout(() => {
          this.scrollToEnd('smooth');
        }, this.animationDuration * 1000);
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$emit('active', this.isActive);
      if (this.isActive) {
        this.scrollToEnd('instant');
      }
    });
  },

  beforeMount() {
    this.showChildren = this.isOpen && this.hasActiveChild(this.IOH.recVal(this.item, 'children', []));
  },

  methods: {
    scrollToEnd(behavior) {
      const el = this.isChild ? this.$el.parentElement.lastElementChild : this.$el;
      el.scrollIntoView({
        behavior,
        block: 'end',
      });
    },

    checkActive(item = this.item) {
      const parts = window.location.host.split('.');
      const urlArray = this.urlPath.split('/').filter((x) => x);

      if (this.IOH.recVal(item, 'active', false)) {
        return this.IOH.recVal(item, 'active', false);
      }

      if (!item.keys && !item.urls) {
        return false;
      }

      if (item.urls?.length) {
        return item.urls.some((url) => this.urlPath.match(url.replace('*', '.*')));
      }

      return item.keys.some((key) => {
        const regMatch = key.match(/app:(\w+)/);

        if (regMatch) {
          const app = regMatch[1];
          const pathKey = key.replace(/app:(\w+)/, '').trim();
          return parts.includes(app) && urlArray.includes(pathKey);
        }
        return urlArray[0] === key;
      });
    },
    showChildrenOrPass(e, url) {
      if (this.hasChildren && !this.showChildren) {
        this.showChildren = true;
        this.$emit('showChildren', this);
      } else if (this.showChildren && !this.item.url) {
        this.showChildren = false;
      } else {
        window.location.href = url;
      }
    },

    hideOtherChildren(newOpenedChild = null) {
      (this.$refs.childs || []).forEach((child) => {
        if (child !== newOpenedChild) {
          child.hideChildren();
        }
      });
    },

    hideChildren() {
      this.showChildren = false;

      this.hideOtherChildren();
    },

    hasActiveChild(children) {
      return children.some((child) => {
        let hasActiveChild = false;

        hasActiveChild = this.checkActive(child) || hasActiveChild;
        hasActiveChild = hasActiveChild || this.hasActiveChild(this.IOH.recVal(child, 'children', []));

        return hasActiveChild;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-icon--overlay {
    height: 0.5em;
    top: 1.175em !important;
}
</style>
